import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../Helpers/Utils";
import Select from "react-select"; // React-select import panniyaachu

const CreateDriver = () => {
    const dispatch = useDispatch();
    const loading = useSelector(s => s.loading.loading);

    // Machan, JSON-la iruntha "driver_info" keys-oda state-ah sync pannitaen
    const [form, setForm] = useState({
        name: "",
        phone: "",
        license_number: "",
        company_name: "",
        basic_salary: "",      // mathiyaachu machan
        office_hours_ot: "",   // mathiyaachu machan
        after_office_ot: "",   // mathiyaachu machan
        holiday_ot: "",        // mathiyaachu machan
        status: "active"       // default-ah active
    });

    // React-select options
    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' }
    ];

    const handleChange = e => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSelectChange = (selectedOption) => {
        setForm({ ...form, status: selectedOption.value });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        dispatch(loadingTrue());

        // Machan, ippo payload exact-ah nee kudutha JSON structure-ku pogum
        const res = await Handler({
            method: "post",
            url: "/driver/create.php",
            data: form
        });

        if (res.success) {
            toast.success(res.message || "Driver Created Successfully");
            setTimeout(() => reloadWindowToPath("/drivers"), 1000);
        } else {
            toast.error(res.message || "Something went wrong");
        }

        dispatch(loadingFalse());
    };

    return (
        <div className="page-card">
            <div className="page-header">
                <h4>Create New Driver</h4>
            </div>

            <form onSubmit={handleSubmit} className="form-grid">
                {/* 1. Basic Info Section */}
                <div className="form-group">
                    <label>Driver Name</label>
                    <input name="name" className="form-control" placeholder="Full Name" value={form.name} onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>Phone Number</label>
                    <input name="phone" className="form-control" maxLength={8}  placeholder="Phone Number" value={form.phone} onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>License Number</label>
                    <input name="license_number" className="form-control" placeholder="License No" value={form.license_number} onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>Company Name</label>
                    <input name="company_name" className="form-control" placeholder="Enter Company Name" value={form.company_name} onChange={handleChange} required />
                </div>

                {/* 2. Updated Salary Rates Section - JSON Keys Sync */}
                <div className="form-group">
                    <label>Basic Salary</label>
                    <input type="number" step="0.01" name="basic_salary" className="form-control" placeholder="0.00" value={form.basic_salary} onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Office Hours OT Salary</label>
                    <input type="number" step="0.01" name="office_hours_ot" className="form-control" placeholder="0.00" value={form.office_hours_ot} onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>After Office OT Salary</label>
                    <input type="number" step="0.01" name="after_office_ot" className="form-control" placeholder="0.00" value={form.after_office_ot} onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Holiday OT Salary</label>
                    <input type="number" step="0.01" name="holiday_ot" className="form-control" placeholder="0.00" value={form.holiday_ot} onChange={handleChange} />
                </div>

                {/* Status Selection using React-Select */}
                <div className="form-group">
                    <label>Status</label>
                    <Select 
                        options={statusOptions}
                        defaultValue={statusOptions[0]}
                        onChange={handleSelectChange}
                        classNamePrefix="react-select"
                    />
                </div>

                <div className="form-group full">
                    <button className="btn add-btn-add py-2 fw-bold shadow-sm" disabled={loading} type="submit">
                        {loading ? (<><span className="spinner-border spinner-border-sm me-2"></span>Saving...</>) : "Register Driver"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CreateDriver;